import { Timestamp } from '@angular/fire/firestore';

export interface Quiz {
  id: string;
  title: string;
  description: string;
  groupId: string;
  createdByName: string;
  createdById: string;
  answerDuration?: number; // For live quiz, duration in seconds for each question
  totalDuration: number; // For scheduled quiz, total duration in minutes
  totalScore: number;

  questions?: string[];
  created: Timestamp;
  modified: Timestamp;
  scheduledAt?: Timestamp; // Optional, for quizzes that are scheduled
  endDate?: Timestamp; // Mandatory for scheduled quizzes
  quizStatus: QuizStatus;

  currentQuestionId?: string; // For live quiz, tracking the current question
  currentIndex?: number; // For scheduled quiz, tracking the current question index in the questions array
  remainingTime?: number; // For scheduled quizzes, remaining time in seconds
  userScore?: number; // For tracking user's score in live quizzes

  isLive?: boolean; // Optional, indicates if the quiz is currently live
  byInvite?: boolean; // Indicates if the quiz is joinable by invite code
  inviteCode?: string; // Optional, code for participants to join the quiz
  completed?: boolean; // Optional, indicates if the attempt is completed
  score?: number; // Optional, total score of the attempt
  userId?: string; // Optional, user who created the attempt
  userName?: string; // Optional, name of the user who created the attempt
  userPhotoUrl?: string; // Optional, photo URL of the user who created the attempt
  enableScoring?: boolean;
  allowMultipleAttempts?: boolean;
  shortAnswerPercentage?: number;
  enableTimeLimit?: boolean;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
}

export enum QuizStatus {
  draft = 'draft',
  waiting = 'waiting',
  inProgress = 'inProgress',
  completed = 'completed',
  scheduled = 'scheduled',
  cancelled = 'cancelled',
}
